import { BuyerSearchResult, BuyerListItem } from '@/types/buyerSearch';

export const buyerExportService = {
  exportToCSV(buyers: BuyerSearchResult[], filename = 'buyers-export.csv') {
    const headers = [
      'Name',
      'Company',
      'Phone',
      'Deals Annually',
      'Subscription Status',
      'Average Close Time',
      'Purchasing Types',
      'Preferred Markets',
      'Created Date'
    ];

    const csvContent = [
      headers.join(','),
      ...buyers.map(buyer => [
        this.escapeCSVField(buyer.full_name),
        this.escapeCSVField(buyer.company_name || ''),
        this.escapeCSVField(buyer.phone_number),
        buyer.deals_annually.toString(),
        this.escapeCSVField(buyer.subscription_status),
        this.escapeCSVField(buyer.average_close_time || ''),
        this.escapeCSVField(buyer.purchasing_type?.join('; ') || ''),
        this.escapeCSVField(buyer.preferred_markets?.join('; ') || ''),
        new Date(buyer.created_at).toLocaleDateString()
      ].join(','))
    ].join('\n');

    this.downloadCSV(csvContent, filename);
  },

  exportBuyerListToCSV(buyerListItems: BuyerListItem[], listName: string) {
    const headers = [
      'Name',
      'Company',
      'Phone',
      'Deals Annually',
      'Subscription Status',
      'Average Close Time',
      'Purchasing Types',
      'Preferred Markets',
      'Notes',
      'Date Added',
      'Created Date'
    ];

    const csvContent = [
      headers.join(','),
      ...buyerListItems.map(item => {
        const buyer = item.buyer_profile;
        if (!buyer) return '';
        
        return [
          this.escapeCSVField(buyer.full_name || ''),
          this.escapeCSVField(buyer.company_name || ''),
          this.escapeCSVField(buyer.phone_number || ''),
          buyer.deals_annually?.toString() || '0',
          this.escapeCSVField(buyer.subscription_status || ''),
          this.escapeCSVField(buyer.average_close_time || ''),
          this.escapeCSVField(buyer.purchasing_type?.join('; ') || ''),
          this.escapeCSVField(buyer.preferred_markets?.join('; ') || ''),
          this.escapeCSVField(item.notes || ''),
          new Date(item.added_at).toLocaleDateString(),
          new Date(buyer.created_at).toLocaleDateString()
        ].join(',');
      }).filter(row => row !== '')
    ].join('\n');

    const sanitizedListName = listName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `${sanitizedListName}_buyers_${timestamp}.csv`;
    
    this.downloadCSV(csvContent, filename);
  },

  escapeCSVField(field: string): string {
    if (field.includes(',') || field.includes('"') || field.includes('\n')) {
      return `"${field.replace(/"/g, '""')}"`;
    }
    return field;
  },

  downloadCSV(content: string, filename: string) {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};